/* AXOLOVE: the main price follows the chosen pack.
 *
 * Where a pack is a quantity discount rather than a variant of its own (belt:
 * Two / Three / Four), the theme keeps showing the price of one unit. Each pack
 * tile's radio carries its total in data-ax-total, formatted by Liquid the same
 * way as the theme's own price, and while that tile is chosen this script writes
 * it into the main <product-price>. "One" (no data-ax-total) puts the theme's
 * price back.
 *
 * The theme replaces the price container after a variant change
 * (product-price.js), so the pack total is re-applied whenever that happens.
 * The cart is untouched: pack totals come from the automatic discounts in
 * Shopify admin, and data-ax-total has to stay in step with them, as the tiles
 * already do.
 */
(function () {
  'use strict';

  var total = null; // formatted total of the chosen pack; null = theme's own price

  function packs() {
    return document.querySelector('[data-ax-packs]');
  }

  function productPrice() {
    var root = packs();
    var scope = (root && root.closest('.shopify-section')) || document;
    return scope.querySelector('product-price');
  }

  // The price text is the last non-empty text node of .price (a sale price
  // also holds a visually hidden label before it).
  function priceText() {
    var host = productPrice();
    var el = host && host.querySelector('[ref="priceContainer"] .price');
    if (!el) return null;
    for (var node = el.lastChild; node; node = node.previousSibling) {
      if (node.nodeType === 3 && node.nodeValue.trim()) return { el: el, node: node };
    }
    return null;
  }

  function apply() {
    var price = priceText();
    if (!price) return;
    // A container fresh from the theme has no mark yet: remember its price.
    if (!price.el.hasAttribute('data-ax-unit')) {
      price.el.setAttribute('data-ax-unit', price.node.nodeValue.trim());
    }
    var want = total || price.el.getAttribute('data-ax-unit');
    if (price.node.nodeValue.trim() !== want) price.node.nodeValue = want;
  }

  function readChoice() {
    var root = packs();
    var input = root && root.querySelector('input[name="ax-pack"]:checked');
    total = (input && input.getAttribute('data-ax-total')) || null;
    apply();
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target instanceof Element && target.matches('[data-ax-packs] input[name="ax-pack"]')) readChoice();
  });

  var host = productPrice();
  if (host) {
    new MutationObserver(apply).observe(host, { childList: true, subtree: true, characterData: true });
  }

  readChoice();
})();
